<template>
  <div>
    <v-alert v-if="protocol.related_protocol" :value="true" color="success" type="success">
      Skjemaet er ferdig utfylt med inventar fra innflyttingsprotokoll
    </v-alert>
    <v-flex xs12>
      <h2 class="text-center mb-3">Inventarliste</h2>
    </v-flex>
    <v-flex xs12 class="mb-2">
      <NumberInputTable
        objectTitle="Inventar"
        commentTitle="Kommentar"
        v-model="stepValues.inventoryList"
        @update-fields="updateFields"
      ></NumberInputTable>
    </v-flex>
    <v-divider></v-divider>
    <v-flex xs12 class="mb-3">
      <v-flex v-if="stepValues.relatedComment" xs12 class="m-4" style="border: 1px dashed orange">
        <span><strong>Kommentar fra innflytting:</strong> {{stepValues.relatedComment}}</span>
      </v-flex>
      <v-textarea box label="Andre kommentarer" v-model="stepValues.comment" @input="updateFields"></v-textarea>
    </v-flex>
    <StepButtons @next-page="next" @previous-page="previous" :step="this" />
  </div>
</template>

<script>
import NumberInputTable from "../form/NumberInputTable.vue";
import INVENTORYLIST from "../../models/inventoryList";
import step from "../../mixins/step";
export default {
  mixins: [step],
  components: { NumberInputTable },
  mounted: function() {
    if(this.protocol.related_protocol && this.stepValues) {
      if(this.stepValues.loadedFromRelated == null || this.stepValues.loadedFromRelated == undefined) {
        if(this.protocol.related_protocol.steps.inventory.saved_values.inventoryList) {
          this.stepValues.loadedFromRelated = true
          this.stepValues.relatedComment = this.protocol.related_protocol.steps.inventory.saved_values.comment
          let inventoryList = JSON.parse( JSON.stringify(this.protocol.related_protocol.steps.inventory.saved_values.inventoryList))
          this.stepValues.inventoryList = inventoryList
        }
      }
    }
    if(this.stepValues.inventoryList) {
      if(this.stepValues.inventoryList.length === 0) {
        this.stepValues.inventoryList = INVENTORYLIST
      }
    }
  }
};
</script>
